// extracted by mini-css-extract-plugin
export default {"burger":"classes_burger__UQkWt"};